<script>
import NumberInput from '@/views/components/inputs/number-input.vue'

export default {
  components: {
    NumberInput
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  },
  data () {
    return {
      p_value: null
    }
  },
  created() {
    this.p_value = this.params.value;
  },  
  methods:{
    getValue() {
      return this.p_value;
    },
    isPopup() {
      return false;
    },
    onkeydown($event, a) {
      if($event.code === 'Escape' || $event.code === 'Tab') {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        return false;
      } else  if($event.code === 'Enter') {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        return false;
      }
    }
  }
};
</script>

<template>
  <div  @keypres="onkeydown"  @keyup="onkeydown"  @keydown="onkeydown" style="width:100%" >
    <number-input
      
      v-model="p_value"
    >
    </number-input>
  </div>
  
 
</template>
